export const GlobalData = {
  ProductList: [],
  FilterCriteria: [],
  ProductListSelection: [],
}
